import {Box, Stack, Typography} from "@mui/material";

function FeatureAccessMessage() {
    return (
        <Stack direction="column" alignItems="center" justifyContent="center" sx={{mt: 6, mb: 6, padding: "24px"}}>
            <Box sx={{
                width: 300,
                height: 300,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#fff7ec",
                borderRadius: "16px",
                border: "3px solid #fbb563",
                boxShadow: "0 4px 24px rgba(0, 0, 0, 0.35), 0 1px 6px rgba(0, 0, 0, 0.2)",
            }}>
                <Box
                    component="img"
                    src="/images/lock_access.svg"
                    alt="Feature Access"
                    sx={{width: 240, height: 240, objectFit: "contain"}}
                />
            </Box>
            <Typography sx={{color: "#38ff82", fontSize: 22, fontWeight: "bold", textAlign: "center", mt: 3, letterSpacing: 3, textTransform: "uppercase"}}>
                Feature Access
            </Typography>
            <Typography sx={{color: "rgba(242, 245, 250, 0.7)", fontSize: 14, fontWeight: 400, textAlign: "center", maxWidth: 320, mt: 1.5, lineHeight: 1.6, letterSpacing: 0.6}}>
                This feature is not currently enabled on your account. Please contact the administrator of your project for more information.
            </Typography>
        </Stack>
    );
}

export default FeatureAccessMessage;
